<template>
	<div :class="containerClass" @click="onWrapperClick">
        <AppTopBar @menu-toggle="onMenuToggle" />
        <div class="layout-sidebar" @click="onSidebarClick">
            <AppMenu :model="menu" @menuitem-click="onMenuItemClick" />
        </div>

        <div class="layout-main-container">
            <div class="layout-main">
                <router-view />
            </div>
            <AppFooter />
        </div>
<!-- 
		<AppConfig :layoutMode="layoutMode" @layout-change="onLayoutChange" /> -->
        <transition name="layout-mask">
            <div class="layout-mask p-component-overlay" v-if="mobileMenuActive"></div>
        </transition>
	</div>
</template>

<script>
import AppTopBar from './AppTopbar.vue';
import AppMenu from './AppMenu.vue';
// import AppConfig from './AppConfig.vue';
import AppFooter from './AppFooter.vue';

export default {
    emits: ['change-theme'],
    data() {
        return {
            layoutMode: 'static',
            staticMenuInactive: false,
            overlayMenuActive: false,
            mobileMenuActive: false,
            menu : [
                {
                    label: 'Dashboard',
                    items: [{
                        label: 'Dashboard', icon: 'pi pi-fw pi-home', to: '/'
                    }]
                },
				{
					label: 'Data', icon: 'pi pi-fw pi-sitemap',
					items: [
                        {label: 'User', icon: 'pi pi-fw pi-user-edit', to: '/data-user'},
					]
				},
				// {
				// 	label: 'Master', icon: 'pi pi-fw pi-sitemap',
				// 	items: [
                //         {label: 'User Hp', icon: 'pi pi-fw pi-user-edit', to: '/master-user-hp'},
                //         {label: 'User Web', icon: 'pi pi-fw pi-user-edit', to: '/master-user-web'},
				// 	]
				// },
				// {
				// 	label: 'Database', icon: 'pi pi-fw pi-database',
				// 	items: [
                //         {label: 'Start End', icon: 'pi pi-fw pi-database', to: '/database-start-end'},
				// 	]
				// },
				{
					label: 'Report', icon: 'pi pi-fw pi-list',
					items: [
                        {label: 'Sales Review', icon: 'pi pi-fw pi-list', to: '/report-sales-review'},
                        {label: 'Business Review', icon: 'pi pi-fw pi-list', to: '/report-business-review'},
                        {label: 'Admin Work', icon: 'pi pi-fw pi-list', to: '/report-admin-work'},
                        {label: 'Join Visit', icon: 'pi pi-fw pi-list', to: '/report-join-visit'},
                        {label: 'Field Tracking', icon: 'pi pi-fw pi-list', to: '/report-field-tracking'},
                        {label: 'Account Development', icon: 'pi pi-fw pi-list', to: '/report-account-development'},
                        {label: 'User Active', icon: 'pi pi-fw pi-list', to: '/report-user-active'},
                        {label: 'ASM Plan', icon: 'pi pi-fw pi-list', to: '/report-call-plan'},
                        {label: 'Compliance', icon: 'pi pi-fw pi-list', to: '/report-compliance'},
					]
				},
            ]
        }
    },
    watch: {
        $route() {
            this.menuActive = false;
            this.$toast.removeAllGroups();
        }
    },
    methods: {
        onWrapperClick() {
            if (!this.menuClick) {
                this.overlayMenuActive = false;
                this.mobileMenuActive = false;
            }

            this.menuClick = false;
        },
        onMenuToggle() {
            this.menuClick = true;

            if (this.isDesktop()) {
                if (this.layoutMode === 'overlay') {
					if(this.mobileMenuActive === true) {
						this.overlayMenuActive = true;
					}

                    this.overlayMenuActive = !this.overlayMenuActive;
					this.mobileMenuActive = false;
                }
                else if (this.layoutMode === 'static') {
                    this.staticMenuInactive = !this.staticMenuInactive;
                }
            }
            else {
                this.mobileMenuActive = !this.mobileMenuActive;
            }

            event.preventDefault();
        },
        onSidebarClick() {
            this.menuClick = true;
        },
        onMenuItemClick(event) {
            if (event.item && !event.item.items) {
                this.overlayMenuActive = false;
                this.mobileMenuActive = false;
            }
        },
		onLayoutChange(layoutMode) {
			this.layoutMode = layoutMode;
		},
        addClass(element, className) {
            if (element.classList)
                element.classList.add(className);
            else
                element.className += ' ' + className;
        },
        removeClass(element, className) {
            if (element.classList)
                element.classList.remove(className);
            else
                element.className = element.className.replace(new RegExp('(^|\\b)' + className.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
        },
        isDesktop() {
            return window.innerWidth >= 992;
        },
        isSidebarVisible() {
            if (this.isDesktop()) {
                if (this.layoutMode === 'static')
                    return !this.staticMenuInactive;
                else if (this.layoutMode === 'overlay')
                    return this.overlayMenuActive;
            }

            return true;
        }
    },
    computed: {
        containerClass() {
            return ['layout-wrapper', {
                'layout-overlay': this.layoutMode === 'overlay',
                'layout-static': this.layoutMode === 'static',
                'layout-static-sidebar-inactive': this.staticMenuInactive && this.layoutMode === 'static',
                'layout-overlay-sidebar-active': this.overlayMenuActive && this.layoutMode === 'overlay',
                'layout-mobile-sidebar-active': this.mobileMenuActive,
				'p-input-filled': this.$primevue.config.inputStyle === 'filled',
				'p-ripple-disabled': this.$primevue.config.ripple === false
            }];
        },
        logo() {
            return (this.$appState.darkTheme) ? "favicon.png" : "favicon.png";
        }
    },
    beforeUpdate() {
        if (this.mobileMenuActive)
            this.addClass(document.body, 'body-overflow-hidden');
        else
            this.removeClass(document.body, 'body-overflow-hidden');
    },
    components: {
        'AppTopBar': AppTopBar,
        'AppMenu': AppMenu,
        // 'AppConfig': AppConfig,
        'AppFooter': AppFooter,
    }
}
</script>

<style lang="scss">
@import './App.scss';
</style>
